export function getPresetPhpTemplate(
  slug: string,
  control: string,
  namespace: string,
  options: string | null
) {
  return `<?php

namespace ${namespace};

use function Breakdance\\Elements\\c;
use function Breakdance\\Elements\\PresetSections\\getPresetSection;

\\Breakdance\\Elements\\PresetSections\\PresetSectionsController::getInstance()->register(
    "${slug}",
    ${control},
    true,
    ${options}
);

`;
}
